import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import {
  JointAssetsLiabilitiesPartOneFormData,
  JointAssetsLiabilitiesPartTwoFormData,
  JointAssetsLiabilitiesPartThreeFormData,
  JointAssetsLiabilitiesPartFourFormData,
} from "app/utils/types";

interface Driverlicenseimages {
  frontImage?: string;
  backImage?: string;
  cofrontImage?: string;
  cobackImage?: string;
}
interface PassportVisaimages {
  passport?: string;
  visa?: string;
  copassport?: string;
  covisa?: string;
}
interface StepsDataTypes {
  assetLiabilityId?: string;
  secoundAssetLiabilityId?: string;
  formOne?: JointAssetsLiabilitiesPartOneFormData;
  formTwo?: JointAssetsLiabilitiesPartTwoFormData;
  formThree?: JointAssetsLiabilitiesPartThreeFormData;
  formFour?: JointAssetsLiabilitiesPartFourFormData;
  passportImage?: string;
  copassportImage?: string;
  driverlicenseimages?: Driverlicenseimages;
  passportVisaimages?: PassportVisaimages;
  bankStatement?: string[];
  cobankStatement?: string[];
  bankStatementTerms?: boolean;
  cobankStatementTerms?: boolean;
  certificate?: string;
  medicareCard?: string;
  cocertificate?: string;
  comedicareCard?: string;
  validAustralianPassport?: boolean;
  covalidAustralianPassport?: boolean;
}

interface StepState {
  currentStep: number;
  stepsData: StepsDataTypes;
}
const initialState: StepState = {
  currentStep: 0,
  stepsData: {},
};
export const jointAssetsLiabilities = createSlice({
  name: "jointAssetsLiabilities",
  initialState,
  reducers: {
    nextStep: (state) => {
      if (state.currentStep < 8) state.currentStep += 1;
    },
    prevStep: (state) => {
      if (state.currentStep >= 1) state.currentStep -= 1;
    },
    setStep: (state, action: PayloadAction<number>) => {
      state.currentStep = action.payload;
    },
    addStepsData: (state, action: PayloadAction<StepsDataTypes>) => {
      state.stepsData = { ...state.stepsData, ...action.payload };
    },
  },
});

export const { nextStep, prevStep, setStep, addStepsData } =
  jointAssetsLiabilities.actions;

export default jointAssetsLiabilities.reducer;
